import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function ProofSection() {
  return <section className="py-12 md:py-14 px-6 bg-sage/10" data-id="element-135">
      <div className="max-w-3xl mx-auto text-center" data-id="element-136">
        <FadeIn data-id="element-137">
          <svg className="w-8 h-8 text-sage mx-auto mb-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-138">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" data-id="element-139" />
          </svg>
          <h2 className="font-serif text-2xl md:text-3xl text-navy mb-4 leading-tight" data-id="element-140">
            En solo 7 días, pasarás de la lucha violenta contra el despertador a
            un estado de calma activa.
          </h2>
        </FadeIn>

        <FadeIn delay={0.15} data-id="element-141">
          <p className="text-base md:text-lg text-navy/80 leading-relaxed" data-id="element-142">
            No prometemos una vida sin problemas, pero prometemos que sabrás
            exactamente cómo poner el primer pie en el suelo con dignidad y paz,
            sin importar qué tan gris sea el cielo.
          </p>
        </FadeIn>
      </div>
    </section>;
}